var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4098_72278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.668 35.2173V25.8004L14.6284 21.9375L12.9528 29.3468L2.5957 27.2433L3.08579 24.8384L10.8303 26.4365L13.6292 12.1886L9.79409 13.7367V19.0829H7.37392V12.1511L13.7781 9.43931C14.595 9.09807 15.197 8.87219 15.5839 8.76166C15.9706 8.65087 16.3264 8.59548 16.6512 8.59548C17.1436 8.59548 17.6007 8.72523 18.0227 8.98472C18.4446 9.24449 18.788 9.59057 19.0528 10.023L20.6663 12.6045C21.3549 13.7132 22.2976 14.646 23.4942 15.403C24.6909 16.16 26.0401 16.5695 27.542 16.6316V19.0518C25.9016 19.0002 24.3162 18.5787 22.7855 17.7873C21.2547 16.9961 19.9494 15.8507 18.8697 14.351L17.6689 20.4172L21.0882 23.7062V35.2173H18.668ZM19.0714 7.13733C18.2461 7.13733 17.5433 6.84718 16.963 6.26688C16.3827 5.68657 16.0926 4.98378 16.0926 4.15851C16.0926 3.33323 16.3827 2.63044 16.963 2.05014C17.5433 1.46984 18.2461 1.17969 19.0714 1.17969C19.8967 1.17969 20.5995 1.46984 21.1798 2.05014C21.7601 2.63044 22.0502 3.33323 22.0502 4.15851C22.0502 4.98378 21.7601 5.68657 21.1798 6.26688C20.5995 6.84718 19.8967 7.13733 19.0714 7.13733Z",
    fill: "#201F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4098_72278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6921,
    height: 33.6921,
    fill: "white",
    transform: "translate(0.78125 0.585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIconBlack);
export default __webpack_public_path__ + "static/media/activityIconBlack.7eaba1759533ef6b471bb4642dad749f.svg";
export { ForwardRef as ReactComponent };